import React from "react";

import { IgPaper } from "@intelligems/ig-theme";
import { Grid, Typography } from "@mui/material";

import { useLoggedInUser } from "../../api/user-auths/login";
import Loading from "../../utils/Loading";

const PersonalInformation: React.FC = () => {
  const user = useLoggedInUser();

  if (user.isSuccess) {
    return (
      <IgPaper sx={{ height: "240px", marginLeft: "8px" }}>
        <Grid container rowSpacing={1} direction={"column"}>
          <Grid item xs={12}>
            <Typography variant="h6">Personal Settings</Typography>
          </Grid>
          {user.data.user.email && (
            <>
              <Grid container direction={"row"} item xs={12}>
                <Typography sx={{ marginRight: "20px", fontWeight: "bold" }}>
                  Name:
                </Typography>
                <Typography>
                  {user.data.user.firstName} {user.data.user.lastName}
                </Typography>
              </Grid>
              <Grid container direction={"row"} item xs>
                <Typography sx={{ marginRight: "20px", fontWeight: "bold" }}>
                  Email:
                </Typography>
                <Typography> {user.data.user.email}</Typography>
              </Grid>
            </>
          )}
          {/*<Grid item sx={{ marginLeft: "5px" }}>*/}
          {/*  <FormControlLabel*/}
          {/*    control={*/}
          {/*      <IgSwitch*/}
          {/*        checked={showIds}*/}
          {/*        color="primary"*/}
          {/*        onClick={() => {*/}
          {/*          dispatch(toggleShowIds());*/}
          {/*        }}*/}
          {/*        sx={{ marginRight: "10px" }}*/}
          {/*      />*/}
          {/*    }*/}
          {/*    label={"Show Ids in the app"}*/}
          {/*  />*/}
          {/*</Grid>*/}
        </Grid>
      </IgPaper>
    );
  }
  return <Loading />;
};

export default PersonalInformation;
